const state = {
  customBrand: null,
  contactInformations: [],
  loadingCustomBrand: false,
  loadingCustomBrandFirstLoad: true,
  activeDevices: { video: false, audio: false },
  currentRoom: null,
  stamps: [],
  keycloak: null,
  labelsOwner: [],
  loading: true,
  newShooting: {
    status: 'create',
    registration: '',
    format: '',
    owner: '',
    stamp: null,
    shooting: [],
    model: null,
    viewImages: {}
  },
  owners: [],
  products: [],
  researchShooting: {
    current: {
      registration: '',
      startDate: null,
      endDate: null,
      types: []
    },
    prev: null
  },
  rooms: [],
  roomDevices: {
    audio: null,
    video: null
  },
  stamps: [],
  shooting: [],
  shootings: [],
  shootingInformation: null,
  shootingStatus: null,
  snackbar: {
    snack: '',
    color: 'success'
  },
  user: null,
  userAccount: null,
  userOptions: null,
  video: {
    videoType: '',
    url: '',
    reference: ''
  },
  editShooting: {
    editionTypeSelected: null,
    isEditMode: false,
    selectedImages: []
  },
  shootingUserInformation: {
    id: '',
    fullName: ''
  },
  shootingCreationDate: null,
  shootingModel: null
}

export default state
